var HTML_ENTITIES = {
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  nbsp: ' ',
  quot: '"'
};

var decodeHtmlEntity = function decodeHtmlEntity(entity) {
  var _HTML_ENTITIES$entity;

  var numericEntity = entity.match(/^&#(x?[0-9a-f]+);$/i);

  if (numericEntity) {
    var value = numericEntity[1];
    var isHexadecimal = value.startsWith('x') || value.startsWith('X');
    var codePoint = Number.parseInt(isHexadecimal ? value.slice(1) : value, isHexadecimal ? 16 : 10);
    return Number.isNaN(codePoint) || codePoint > 0x10ffff ? entity : String.fromCodePoint(codePoint);
  }

  return (_HTML_ENTITIES$entity = HTML_ENTITIES[entity.slice(1, -1).toLowerCase()]) !== null && _HTML_ENTITIES$entity !== void 0 ? _HTML_ENTITIES$entity : entity;
};

export var getEssayPlainText = function getEssayPlainText(content) {
  return content.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(?:p|div|li|td|th|tr|h[1-6])>/gi, '\n').replace(/<[^>]*>/g, ' ').replace(/&(?:#x?[0-9a-f]+|amp|apos|gt|lt|nbsp|quot);/gi, decodeHtmlEntity).replace(/[\t\f\v ]+/g, ' ').replace(/ *\n */g, '\n');
};
export var countWords = function countWords(content) {
  var text = getEssayPlainText(content).trim();
  return text ? text.split(/\s+/).length : 0;
};
export var countCharacters = function countCharacters(content) {
  return Array.from(getEssayPlainText(content).trim()).length;
};
export var hasEssayContent = function hasEssayContent(content) {
  return Boolean(getEssayPlainText(content).trim()) || /<(?:img|audio|video|iframe|table|svg|math)\b/i.test(content);
};
export var normalizeEssayContent = function normalizeEssayContent(content) {
  return content.replace(/\s+/g, ' ').trim();
};